import { render, staticRenderFns } from "./botTb.vue?vue&type=template&id=19730b08&"
import script from "./botTb.vue?vue&type=script&lang=js&"
export * from "./botTb.vue?vue&type=script&lang=js&"
import style0 from "./botTb.vue?vue&type=style&index=0&id=19730b08&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports